



export class GlobalSettingsVM {
    
    passwordRules?: string;
    
    minAge?: number;
    
    counsellorSearchResultsPerPage?: number;
    
    counsellorWorkingHoursStart?: string;
    
    counsellorWorkingHoursEnd?: string;
    
}
